import React, { useState,useEffect } from 'react';
import { NavLink } from "react-router-dom";
import { setDateRange,dynamicUrl } from '../Function';
import { useDynamicLink } from '../DynamicUse';
import { Container,Row,Col,ListGroup,Placeholder, Card } from 'react-bootstrap';
const HpEventNotice = () => 
{
    const AllNotice = useDynamicLink(193);
    const AllEvents = useDynamicLink(194);
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[ueLoading, setueLoading] = useState(true);
    const[ueData,setUe]=useState([])
    const[peLoading, setpeLoading] = useState(true);
    const[peData,setPe]=useState([])
    const[ncLoading, setncLoading] = useState(true);
    const[ncData,setNc]=useState([])
    useEffect(()=>
    {
        upcomingEvents();
        noticeTen();
        pastEvents();
    },[])
    const upcomingEvents = async () => 
    {
      try 
      {
        var cTime = Math.round((new Date()).getTime() / 1000);
        const response = await fetch(global.config.API_URL+"events/upcomingEvents/"+cTime);
        const result = await response.json();
        if (result.length > 0 ) 
        {
            setUe(result);
            setueLoading(false);
            if( global.config.IsPrint === true )
            {
              console.info('Upcoming 10 Events : Result',result);
            }  
        }
        else
        {
            setUe([]);
            setueLoading(false);
        }
      }
      catch (error) 
      {
        console.error('Upcoming 10 Events : Error', error.message);
        setueLoading(false);
      }
    };
    const noticeTen = async () => 
    {
      try 
      {            
        const { startDate, endDate } = setDateRange(0, 0, 0, 0, 1);
        const callApi = global.config.API_URL + `notices/list/4/none/${startDate}/${endDate}/0`;
        if(global.config.IsPrint) console.info('NoticesList : API', callApi);
        const response = await fetch(callApi);
        const result = await response.json();
        if (result.length > 0) 
        {
            setNc(result);
            setncLoading(false);
            if( global.config.IsPrint === true )
            {
              console.info('Latest Circular : Result',result);
            }  
        }
        else
        {
            setNc([]);
            setncLoading(false);
        }
      }
      catch (error) 
      {
        console.error('Latest Circular : Error', error.message);
        setncLoading(false);
      }
    };
    const pastEvents = async () => 
    {
      try 
      {
        var cTime = Math.round((new Date()).getTime() / 1000);
        const response = await fetch(global.config.API_URL+"events/pastEvents/"+cTime);
        const result = await response.json();
        if ( result.length > 0 ) 
        {  
            setPe(result);
            setpeLoading(false);
            if( global.config.IsPrint === true )
            {
              console.info('Past 10  Events : Result',result);
            }  
        }
        else
        {
            setPe([]);
            setpeLoading(false);
        }
      }
      catch (error) 
      {
        console.error('Past 10 Events : Error', error.message);
        setpeLoading(false);
      }
    };
    return (
        <section className="hp-event-notice">
            <Container className="py-3 py-md-5 text-start">
                <Row className='g-3'>
                    <Col lg={4}>                        
                        <Card className='shadow h-100' data-aos="fade-right" data-aos-duration="1500">
                            <div className='h4 my-2 text-center'>{appLanguage === 'hi' ? 'आगामी कार्यक्रम' : 'Upcoming Events'}</div>
                            <span className="mx-auto mb-0 sub-heading"></span>
                            <Card.Body className='overflow-hidden overflow-y-auto' style={{height:"300px"}}>
                            {ueLoading ? (
                                <ListGroup variant="flush">
                                    {[...Array(5)].map((_,index)=>(
                                        <ListGroup.Item key={index}>
                                            <Placeholder xs={12} />
                                        </ListGroup.Item>
                                    ))}
                                </ListGroup>
                            ) : (
                                <React.Fragment>
                                    { ueData && ueData.length === 0 ? (                                    
                                        <big>{appLanguage === 'hi' ? 'कोई आगामी कार्यक्रम नहीं मिला.' : 'There is no upcoming event found.'}</big>
                                    ) : (
                                    <ListGroup variant="flush">
                                    {ueData.map((ue, index)=>(
                                        <NavLink key={index} to={appLanguage ==='hi' ? `/घटनाक्रम/विवरण/${ue.se_htaccess_hi || ue.se_htaccess}` : `/event/details/${ue.se_htaccess}`} className='list-group-item list-group-item-action d-flex align-items-start px-0' target='_blank' rel="noopener noreferrer">
                                            <span className='px-3 py-2 border rounded bg-info-subtle text-info me-3'>
                                                <i className="bi bi-calendar3"></i>
                                            </span>
                                            <div dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? (ue.se_display_en === "1" ? ue.se_name_hi || '' : ue.se_name_hi || ue.se_name) : ue.se_name }}></div>
                                        </NavLink>
                                    ))}
                                    </ListGroup>
                                    )}
                                </React.Fragment>                                
                            )}
                            </Card.Body>                            
                            <Card.Footer className='bg-transparent border-0'>
                            {AllEvents && AllEvents.map((sp,index)=>(
                                <NavLink key={index} to={dynamicUrl(sp)} className="fw-bold" aria-label={ appLanguage === 'hi' ? sp.sp_name_hi || sp.sp_name : sp.sp_name }>
                                    {appLanguage === 'hi' ? 'सभी देखें' : 'View All'} <i className="bi bi-chevron-right"></i>
                                </NavLink>
                            ))}
                            </Card.Footer>                            
                        </Card>                   
                    </Col>
                    <Col lg={4}>
                        <Card className='shadow h-100' data-aos="fade-down" data-aos-duration="1500">
                            <div className='h4 my-2 text-center'>{appLanguage === 'hi' ? 'सूचना/परिपत्र' : 'Notices / Circulars'}</div>
                            <span className="mx-auto mb-0 sub-heading"></span>
                            <Card.Body className='overflow-hidden overflow-y-auto' style={{height:"300px"}}>
                            {ncLoading ? (
                                <ListGroup variant="flush">
                                    {[...Array(5)].map((_,index)=>(
                                        <ListGroup.Item key={index}>
                                            <Placeholder xs={12} />
                                        </ListGroup.Item>
                                    ))}
                                </ListGroup>
                            ) : (
                            <React.Fragment>                                       
                                { ncData && ncData.length === 0 ? (
                                        <big>{appLanguage === 'hi' ? 'कोई सूचना/परिपत्र नहीं मिला।' : 'There is no notice / Circulars found.'}</big>
                                ) : (
                                    <ListGroup variant="flush">
                                        {ncData.map((nc, index)=>(
                                            <NavLink key={index} to={appLanguage === 'hi' ? `/नोटिस/विवरण/${nc.sn_htaccess_hi || nc.sn_htaccess}` : `/notice/details/${nc.sn_htaccess}`} className='list-group-item list-group-item-action d-flex align-items-start px-0' target='_blank' rel="noopener noreferrer">
                                                <span className='px-3 py-2 border rounded bg-info-subtle text-info me-3'>
                                                    <i className="bi bi-megaphone"></i>
                                                </span>
                                                <div dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? (nc.sn_display_en === "1" ? nc.sn_name_hi || '' : nc.sn_name_hi || nc.sn_name) : nc.sn_name }}></div>                                                
                                            </NavLink>
                                        ))}                 
                                    </ListGroup>
                                )}                            
                            </React.Fragment>
                            )} 
                            </Card.Body>
                            <Card.Footer className='bg-transparent border-0'>
                            {AllNotice && AllNotice.map((sp,index)=>(
                                <NavLink key={index} to={dynamicUrl(sp)} className="fw-bold" aria-label={ appLanguage === 'hi' ? sp.sp_name_hi || sp.sp_name : sp.sp_name }>
                                    {appLanguage === 'hi' ? 'सभी देखें' : 'View All'} <i className="bi bi-chevron-right"></i>
                                </NavLink>
                            ))}
                            </Card.Footer>
                        </Card>                           
                    </Col>
                    <Col lg={4}>
                        <Card className='shadow h-100' data-aos="fade-left" data-aos-duration="1500">
                            <div className='h4 my-2 text-center'>{appLanguage === 'hi' ? 'विगत घटनाएँ' : 'Past Events'}</div>
                            <span className="mx-auto mb-0 sub-heading"></span>
                            <Card.Body className='overflow-hidden overflow-y-auto' style={{height:"300px"}}>
                            {peLoading ? (
                                <ListGroup variant="flush">
                                    {[...Array(5)].map((_,index)=>(
                                        <ListGroup.Item key={index}>
                                            <Placeholder xs={12} />
                                        </ListGroup.Item>
                                    ))}
                                </ListGroup>
                            ) : (
                            <React.Fragment>                                       
                                { peData && peData.length === 0 ? (
                                    <big>{appLanguage === 'hi' ? 'कोई पिछली घटना नहीं मिली.' : 'There is no past event found.'}</big>                                       
                                ) : (
                                    <ListGroup variant="flush">
                                        {peData.map((pe, index)=>(
                                            <NavLink key={index} to={appLanguage ==='hi' ? `/घटनाक्रम/विवरण/${pe.se_htaccess_hi || pe.se_htaccess}` : `/event/details/${pe.se_htaccess}`} className='list-group-item list-group-item-action d-flex align-items-start px-0' target='_blank' rel="noopener noreferrer">
                                                <span className='px-3 py-2 border rounded bg-info-subtle text-info me-3'>
                                                    <i className="bi bi-calendar-check-fill"></i>
                                                </span>
                                                <div dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? (pe.se_display_en === "1" ? pe.se_name_hi || '' : pe.se_name_hi || pe.se_name) : pe.se_name }}></div>
                                            </NavLink>
                                        ))}                                       
                                    </ListGroup>
                                )}                            
                            </React.Fragment>
                            )}
                            </Card.Body>
                            <Card.Footer className='bg-transparent border-0'>
                                {AllEvents && AllEvents.map((sp,index)=>(
                                    <NavLink key={index} to={dynamicUrl(sp)} className="fw-bold" aria-label={ appLanguage === 'hi' ? sp.sp_name_hi || sp.sp_name : sp.sp_name }>
                                        {appLanguage === 'hi' ? 'सभी देखें' : 'View All'} <i className="bi bi-chevron-right"></i>
                                    </NavLink>
                                ))}
                            </Card.Footer>
                        </Card>                                                    
                    </Col>
                </Row>
            </Container>
        </section>
    );
    
}
export default HpEventNotice;